<template>
  <div class="pb-3">
    <section id="api_tasks_remove" class="pt-2">
      <h4 class="pb-2">Удаление задачи</h4>
      <div class="nav-api">
        <ul class="nav nav-tabs nav-tabs-clean">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="post">GET</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">{{ url }}/{{ method }}/:id/remove</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Параметры</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>id</td>
                  <td>целое число</td>
                  <td>обязательный параметр</td>
                  <td>ID задачи</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="example">Пример</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div
            class="tab-pane fade show active">curl -H "Authorization: Bearer {{ token }}" {{ url }}/{{ method }}/1/remove</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="success">Ответ</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">
            <pre class="mb-0">HTTP/1.1 200 OK
{
  "status": "success"
}</pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: ['url', 'token', 'user'],
    data() {
      return {
        method: 'v1/tasks'
      }
    }
  }
</script>